import {
  FEED_IMPORT_BASE,
  FEED_IMPORT_STATUS_BASE,
  GOOGLE_IMPORT_SECRET_BASE,
  adsAssistantClientFetch,
  type AdsAssistantFetchResult,
} from "./adsAssistantClientHttp";

export type AdsFeedImportStatusPayload = {
  ok: true;
  ghl: {
    active_connections: number;
    connections: { id: string; company_name: string | null; has_api_key: boolean }[];
    needs_connection_id: boolean;
  };
  mappings: {
    locations_total: number;
    locations_with_facebook_page_id: number;
    locations_with_google_business_location_id: number;
  };
  meta: { configured: boolean; encryption_configured: boolean };
  google: { configured: boolean; encryption_configured: boolean };
};

export async function fetchAdsFeedImportStatus(): Promise<AdsAssistantFetchResult<AdsFeedImportStatusPayload>> {
  return adsAssistantClientFetch(FEED_IMPORT_STATUS_BASE, { method: "GET" });
}

export async function getAdsGoogleImportSecret(): Promise<
  AdsAssistantFetchResult<{
    ok: true;
    configured: boolean;
    updated_at: string | null;
    encryption_configured: boolean;
    can_edit_google_credentials: boolean;
  }>
> {
  return adsAssistantClientFetch(GOOGLE_IMPORT_SECRET_BASE, { method: "GET" });
}

export async function putAdsGoogleImportSecret(body: {
  service_account_json?: string;
  clear?: boolean;
}): Promise<AdsAssistantFetchResult<{ ok: true; saved?: boolean; cleared?: boolean }>> {
  return adsAssistantClientFetch(GOOGLE_IMPORT_SECRET_BASE, {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  });
}

export async function deleteAdsGoogleImportSecret(): Promise<
  AdsAssistantFetchResult<{ ok: true; cleared?: boolean }>
> {
  return adsAssistantClientFetch(GOOGLE_IMPORT_SECRET_BASE, { method: "DELETE" });
}

export { FEED_IMPORT_BASE };
